import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StartReapplyRecipesRunMutationVariables = Types.Exact<{
  input: Types.ReapplyRecipesInput;
}>;


export type StartReapplyRecipesRunMutation = { __typename?: 'Mutation', startReapplyRecipesRun: { __typename?: 'StartReapplyRecipesRunPayload', run?: { __typename?: 'ReapplyRecipesRun', runId: string, status: Types.ReapplyRecipesRunStatus, totalJobs: number, processedJobs: number, appliedJobs: number, failedResults: Array<{ __typename?: 'ReapplyRecipesJobResult', productionLotId: string, productionJobId: string, productionRecipeId: string, previewedAtRecipeVersion: number, currentRecipeVersion: number, fullyReconciled: boolean, applied: Array<{ __typename?: 'RecipeChangeApplied', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, expectedEventFingerprint?: string | null }>, skipped: Array<{ __typename?: 'RecipeChangeSkipped', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, reason: string }>, failed: Array<{ __typename?: 'RecipeChangeFailed', variationId: string, changeType: string, fieldName?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> }>, errors: Array<{ __typename?: 'ReapplyError', productionJobId: string, variationId?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> } | null, errors: Array<{ __typename?: 'ReapplyError', productionJobId: string, variationId?: string | null, eventListName?: string | null, eventId?: string | null, code: string, message: string }> } };


export const StartReapplyRecipesRunDocument = new TypedDocumentString(`
    mutation StartReapplyRecipesRun($input: ReapplyRecipesInput!) {
  startReapplyRecipesRun(input: $input) {
    run {
      ...ReapplyRecipesRunFields
    }
    errors {
      ...ReapplyErrorFields
    }
  }
}
    fragment ReapplyRecipesRunFields on ReapplyRecipesRun {
  runId
  status
  totalJobs
  processedJobs
  appliedJobs
  failedResults {
    ...ReapplyRecipesJobResultFields
  }
  errors {
    ...ReapplyErrorFields
  }
}
fragment ReapplyRecipesJobResultFields on ReapplyRecipesJobResult {
  productionLotId
  productionJobId
  productionRecipeId
  previewedAtRecipeVersion
  currentRecipeVersion
  fullyReconciled
  applied {
    ...RecipeChangeAppliedFields
  }
  skipped {
    ...RecipeChangeSkippedFields
  }
  failed {
    ...RecipeChangeFailedFields
  }
}
fragment RecipeChangeAppliedFields on RecipeChangeApplied {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  expectedEventFingerprint
}
fragment RecipeChangeSkippedFields on RecipeChangeSkipped {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  reason
}
fragment RecipeChangeFailedFields on RecipeChangeFailed {
  variationId
  changeType
  fieldName
  eventListName
  eventId
  code
  message
}
fragment ReapplyErrorFields on ReapplyError {
  productionJobId
  variationId
  eventListName
  eventId
  code
  message
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StartReapplyRecipesRun: build.mutation<StartReapplyRecipesRunMutation, StartReapplyRecipesRunMutationVariables>({
      query: (variables) => ({ document: StartReapplyRecipesRunDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStartReapplyRecipesRunMutation } = injectedRtkApi;
